/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ListAllPartsForOfflineQueryResponse, ListAllPartsForOfflinePathParams, ListAllPartsForOfflineQueryParams, ListAllPartsForOffline400, ListAllPartsForOffline401, ListAllPartsForOffline403, ListAllPartsForOffline404, ListAllPartsForOffline409, ListAllPartsForOffline500 } from "../../types/equipmentController/ListAllPartsForOffline.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { listAllPartsForOffline } from "../../client/equipmentController/listAllPartsForOffline.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listAllPartsForOfflineQueryKey = (organizationId: ListAllPartsForOfflinePathParams["organizationId"] | undefined, params?: ListAllPartsForOfflineQueryParams) => [{ url: '/api/organizations/:organizationId/equipment/parts/all', params: {organizationId:organizationId} }, ...(params ? [params] : [])] as const

export type ListAllPartsForOfflineQueryKey = ReturnType<typeof listAllPartsForOfflineQueryKey>

export function listAllPartsForOfflineQueryOptions(organizationId: ListAllPartsForOfflinePathParams["organizationId"] | undefined, params?: ListAllPartsForOfflineQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listAllPartsForOfflineQueryKey(organizationId, params)
        return queryOptions<ListAllPartsForOfflineQueryResponse, ResponseErrorConfig<ListAllPartsForOffline400 | ListAllPartsForOffline401 | ListAllPartsForOffline403 | ListAllPartsForOffline404 | ListAllPartsForOffline409 | ListAllPartsForOffline500>, ListAllPartsForOfflineQueryResponse, typeof queryKey>({
         enabled: !!(organizationId),
         queryKey,
         queryFn: async ({ signal }) => {
            return listAllPartsForOffline(organizationId!, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Full non-paginated parts dataset for offline preparation (capped at 10 000)
 * {@link /api/organizations/:organizationId/equipment/parts/all}
 */
export function useListAllPartsForOffline<TData = ListAllPartsForOfflineQueryResponse, TQueryData = ListAllPartsForOfflineQueryResponse, TQueryKey extends QueryKey = ListAllPartsForOfflineQueryKey>(organizationId: ListAllPartsForOfflinePathParams["organizationId"] | undefined, params?: ListAllPartsForOfflineQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListAllPartsForOfflineQueryResponse, ResponseErrorConfig<ListAllPartsForOffline400 | ListAllPartsForOffline401 | ListAllPartsForOffline403 | ListAllPartsForOffline404 | ListAllPartsForOffline409 | ListAllPartsForOffline500>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listAllPartsForOfflineQueryKey(organizationId, params)
         

         const query = useQuery({
          ...listAllPartsForOfflineQueryOptions(organizationId, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListAllPartsForOffline400 | ListAllPartsForOffline401 | ListAllPartsForOffline403 | ListAllPartsForOffline404 | ListAllPartsForOffline409 | ListAllPartsForOffline500>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}